var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferToPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.871 14.28l1.22-1.22A.75.75 0 0010.03 12l-2.324 2.323a1 1 0 000 1.414l2.323 2.324A.75.75 0 1011.09 17l-1.219-1.22h6.44a.75.75 0 000-1.5H9.87zM13.073 11l1.22-1.22h-6.44a.75.75 0 110-1.5h6.44l-1.22-1.22A.75.75 0 1114.133 6l2.324 2.323a1 1 0 010 1.414l-2.323 2.324A.75.75 0 0113.074 11z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.173 2.761a10 10 0 117.654 18.478A10 10 0 018.173 2.761zM12 3.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: "currentColor"
  })));
}
SvgTransferToPlayer.displayName = 'TransferToPlayer';
export default SvgTransferToPlayer;